import type { LevelFactory } from '@/components/factory';

interface Props {
    factory: LevelFactory;
    title: string;
    productName?: string;
    prefix?: string;
    path: string;
}

export const StructuredData = ({ factory, title, productName, prefix, path }: Props) => {
    const { breadcrumbList, destination, price } = factory.structuredDataValues(path);

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'BreadcrumbList',
                        itemListElement: [
                            {
                                '@type': 'ListItem',
                                position: 1,
                                item: {
                                    '@id': `https://www.finn.no${path}`,
                                    '@type': 'webpage',
                                    name: title,
                                },
                            },
                            ...breadcrumbList,
                        ],
                    }),
                }}
            />
            {price ? (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'Product',
                            name: productName ?? `${prefix} ${destination}`,
                            offers: {
                                '@type': 'AggregateOffer',
                                lowPrice: price,
                                priceCurrency: 'NOK',
                            },
                        }),
                    }}
                />
            ) : null}
        </>
    );
};
